/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'enterprise-auth-big': {
    width: 16,
    height: 16,
    viewBox: '0 0 96 96',
    data: '<defs/><g id="复杂大型图标"><path pid="0" class="cls-1" d="M56 28H40v-8h16zm32 0H64v-8l-8-8H40l-8 8v8H8v28h32v-8h16v8h32zM40 64v-4H12v24h72V60H56v4z"/><path pid="1" class="cls-2" d="M40 20h8v8h-8z"/><path pid="2" class="cls-3" d="M40 64v-4H12.04v24H48V64h-8z"/><path pid="3" class="cls-1" d="M84 60H56v4h-8v20h36V60z"/><path pid="4" class="cls-3" d="M40 28H8v28h32v-8h8V28h-8z"/><path pid="5" class="cls-1" d="M80 28H48v20h8v8h32V28h-8z"/><path pid="6" class="cls-3" d="M48 20v-8h-8l-8 8v8h8v-8h8z"/><path pid="7" class="cls-4" d="M56 12h-8v8h8v8h8v-8l-8-8z"/><path pid="8" class="cls-1" d="M56 12h-8v8h8v8h8v-8l-8-8z"/><path pid="9" class="cls-5" d="M40 28v-2.05L32.33 28H40zM64 28v-2.05L56.33 28H64z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/enterprise-auth-big.js